import { DISPLAY } from 'constants/display'

export const getFormattedPercentage = (data?: null | number | string) =>
  data ? `${Math.floor(Number(data))}%` : DISPLAY.empty
